export default __webpack_public_path__ + "static/media/banner_2.04a916c7.jpg";